<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_702_5016)">
      <path
        d="M0 12.0006C0 13.4684 0.264047 14.8745 0.746391 16.1745L12 17.218L23.2536 16.1745C23.736 14.8745 24 13.4684 24 12.0006C24 10.5327 23.736 9.12667 23.2536 7.82669L12 6.7832L0.746391 7.82669C0.264047 9.12667 0 10.5327 0 12.0006H0Z"
        fill="#FFDA44"
      />
      <path
        d="M23.2533 7.82611C21.5578 3.25655 17.1593 0 11.9997 0C6.84012 0 2.44161 3.25655 0.746094 7.82611H23.2533Z"
        fill="#D80027"
      />
      <path
        d="M0.746094 16.1738C2.44161 20.7434 6.84012 23.9999 11.9997 23.9999C17.1593 23.9999 21.5578 20.7434 23.2533 16.1738H0.746094Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_702_5016">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script lang="ts">
import { defineComponent } from "vue"
export default defineComponent({})
</script>
